import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const LightningIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('LightningIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M11,23c-0.13,0-0.27-0.03-0.4-0.08c-0.41-0.18-0.65-0.6-0.59-1.04L10.87,15H3c-0.39,0-0.74-0.22-0.91-0.58
	c-0.16-0.35-0.11-0.77,0.14-1.06l10-12c0.28-0.34,0.76-0.45,1.17-0.28c0.41,0.18,0.65,0.6,0.59,1.04L13.13,9H21
	c0.39,0,0.74,0.22,0.91,0.58c0.17,0.35,0.11,0.77-0.14,1.06l-10,12C11.57,22.87,11.29,23,11,23z M5.14,13H12
	c0.29,0,0.56,0.12,0.75,0.34c0.19,0.22,0.28,0.5,0.24,0.79l-0.58,4.62L18.87,11H12c-0.29,0-0.56-0.12-0.75-0.34
	c-0.19-0.21-0.28-0.5-0.24-0.79l0.58-4.62L5.14,13z"
    />
  </svg>
);

export default LightningIcon;
